<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<md-card>
					<md-card-header>
						<md-card-header-text>
							<div class="md-title">{{ title }}</div>
							<vs-alert icon-pack="feather" icon="icon-info" color="warning" active="true"
								style="height: auto !important;">
								La información aquí presentada corresponde a los últimos 90 días de operaciones.
							</vs-alert>
						</md-card-header-text>

					</md-card-header>
					<md-card-content>
						<div class="row">
							<div class="col">
								<md-field md-clearable v-on:md-clear="cleanTerm()">
									<label>Buscar proyecto</label>
									<md-input v-model="term" @keyup.enter="_findProjects()"></md-input>
								</md-field>
							</div>
							<div class="col">
								<md-field>
									<label for="filter_status">Estatus de proyecto</label>
									<md-select disabled v-model="mutableFilters['projects.status']" name="filter_status"
										id="filter_status" multiple>
										<md-option v-show="s.value == mutableFilters['projects.status']"
											v-bind:key="s.value" v-for="s in opsApprovedStatus" :value="s.value">{{ s.text
											}}</md-option>
									</md-select>
								</md-field>
							</div>
						</div>
					</md-card-content>


					<vs-table ref="table" stripe pagination @dblSelection="handleDblSelected" :max-items="itemsPerPage"
						:data="projects" noDataText="No se encontraron resultados">
						<div slot="header" class="ml-4 mt-2 mb-base flex items-center flex-grow justify-left">

							<span class="ml-2 mr-4">Mostrando {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{
								projects.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage :
								projects.length }} de <strong>{{ projects.length }}</strong> </span>

							<vs-dropdown v-if="isMounted" vs-trigger-click
								class="cursor-pointer ml-4 items-per-page-handler">
								<div
									class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center font-medium">
									<span class="mr-2 text-sm">Regs. por página: {{ itemsPerPage }}</span>
									<feather-icon icon="ChevronDownIcon" svgClasses="h-5 w-5" />
								</div>
								<vs-dropdown-menu>
									<vs-dropdown-item v-for="it in itemsPerPageDefinitions" @click="updateItemsPerPage(it)"
										:key="it">
										<span>{{ it }}</span>
									</vs-dropdown-item>
								</vs-dropdown-menu>
							</vs-dropdown>

							<div class="ml-6">
								<vs-button size="large" color="success" icon="refresh" @click="refreshTable()"></vs-button>
							</div>

							<div class="ml-6">
								<vx-tooltip title="Notas" color="primary" style="cursor:pointer" position="top"
									text="Click sobre ID de proyecto para abrir detalle en un nuevo tab. Doble click sobre la fila para abrir en este tab.">
									<vs-chip color="primary">?</vs-chip>
								</vx-tooltip>
							</div>

						</div>

						<template slot="thead">
							<vs-th class="bold" sort-key="id">ID</vs-th>
							<vs-th class="bold" sort-key="type">TIPO</vs-th>
							<vs-th class="bold" sort-key="client">CLIENTE</vs-th>
							<vs-th class="bold" sort-key="tradename">PROVEEDOR</vs-th>
							<vs-th class="bold" sort-key="status">ESTATUS</vs-th>
							<vs-th class="bold" sort-key="status">FECHA DE ACEPTACIÓN</vs-th>
							<vs-th class="bold" sort-key="status">VERIFICACIÓN DE IDENTIDAD</vs-th>
							<vs-th class="bold" sort-key="tt">TT (DÍAS)</vs-th>
							<vs-th class="bold" sort-key="light">SEM.</vs-th>
							<vs-th class="bold" sort-key="light" v-if="projectStatus === 6">VER</vs-th>
						</template>

						<template slot-scope="{data}">
							<vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
								<vs-td>
									<vs-button type="line" @click="handleSelected(tr)">{{ tr.id }}</vs-button>
								</vs-td>
								<vs-td>
									<vs-chip :color="clientTypeColor(tr.type)" class="extended">
										<strong>{{ tr.type }}</strong>
									</vs-chip>
								</vs-td>
								<vs-td>
									<strong>{{ tr.client }}</strong><br>
									Tel: <span class="colored">{{ tr.phone }}</span><br>
									Alias: <span class="colored">{{ tr.alias }}</span><br>
									<div class="clickable" @click.stop="currentLead = tr.pgmApplicant, popupActivo = true">
										<vs-chip v-if="tr.pgmApplicant" color="#f44336">
											<strong>{{ tr.pgmApplicant.program_info.name }}</strong>
										</vs-chip>
									</div>
								</vs-td>
								<vs-td>{{ tr.tradename||"Sin proveedor" }}</vs-td>
								<vs-td>
									<vs-chip :color="statusColor(tr.status)">
										<strong>{{ tr.statusStr }}</strong>
									</vs-chip>
								</vs-td>
								<vs-td>
									{{ explicitDateFormat(tr.credit_acceptance_date) }}
								</vs-td>
								<vs-td>{{ tr.identity }}</vs-td>
								<vs-td>{{ tr.tt }}</vs-td>
								<vs-td>
									<div class="triage" :class="tr.light"></div>
								</vs-td>
								<vs-td v-if="projectStatus === 6">
									<vs-button type="line" color="#540012" icon="remove_red_eye"
										@click="openInfoDialog(tr)"></vs-button>
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
					<br><br><br>
					<vs-popup :active.sync="showInfoDialog" :title="popupTitle" v-if="projectStatus === 6">
						<vs-table :data="projectContracts" noDataText="No se encontraron resultados">
							<template slot="thead">
								<vs-th class="bold" sort-key="name">Nombre</vs-th>
								<vs-th class="bold" sort-key="status">Estatus</vs-th>
								<vs-th class="bold" sort-key="signing_type">Método de Firma</vs-th>
							</template>

							<template slot-scope="{data}">
								<vs-tr :key="indextr" v-for="(tr, indextr) in projectContracts" :data="tr">
									<vs-td>{{ tr.name }}</vs-td>
									<vs-td>
										<span class="label" v-bind:class="{
											'label-status-1': (tr.status == 'signed'),
											'label-status-10': (tr.status == 'generated' || tr.status == 'sent'),
											'label-status-9': (tr.status == 'canceled')
										}">
											{{ tr.status }}</span>
									</vs-td>
									<vs-td v-if="tr.signing_type == 1">Autógrafa Manual</vs-td>
									<vs-td v-else-if="tr.signing_type == 2">MIFIEL</vs-td>
									<vs-td v-else-if="tr.signing_type == 3">Autógrafa Digital (FAD)</vs-td>
									<vs-td v-else />
								</vs-tr>
							</template>
						</vs-table>
					</vs-popup>
				</md-card>
			</div>
		</div>


		<!-- INFORMACIÓN DE PROGRAMA -->
		<vs-popup v-if="currentLead" class="mid-popup header-primary" title="Detalle del lead de programa"
			:active.sync="popupActivo">
			<vx-card>
				<h3>Información</h3>
				<div class="vx-row">
					<div class="vx-col w-full">
						<p class="bold">Cliente: </p> <span>{{ currentLead.customer_uid }} | {{ currentLead.customer_name
						}}</span> <br>
						<p class="bold">Zona | Región: </p> <span> {{ getZone(currentLead) }} | {{ getRegion(currentLead)
						}}</span> <br>
					</div>
				</div>
			</vx-card>
		</vs-popup>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { humanDateFilter } from "./admin/filters/humanDateFilter";
import { diffDays } from "./admin/filters/diffDays";
import dateHelper from "./mixins/dateHelper";
import userIdentityHelper from "../helpers/userIdentityHelper";

const PFAE_PM_CROWDFUNDING_LOAN_TYPE = 2;
const PF_CROWDFUNDING_LOAN_TYPE = 1;

export default {
	name: "projects-request-list-cutom",
	mixins: [dateHelper, userIdentityHelper],
	props: {
		filters: {
			type: Object,
			required: true,
			default: () => ({}),
		},
		variant: String,
		order: String,
		projectStatus: Number,
		dateToConsult: String,
		title: String,
		auxiliarDate: {
			type: String,
			required: false,
			default: ""
		}

	},
	filters: {
		humanDate: humanDateFilter,
		diffDays: diffDays,
	},
	data() {
		return {
			current_page: 1,
			mutableOrder: _.clone(this.order),
			mutableFilters: _.clone(this.filters),
			mutableApproveStatus: "",
			projects: [],
			term: "",

			PM_CLIENT_TYPE: 0,
			PF_CLIENT_TYPE: 1,
			PFAE_TAX_PROFILE: 1,
			itemsPerPage: 10,

			isMounted: false,
			itemsPerPageDefinitions: [10, 15, 20, 30, 50],
			currentItemsPage: 0,

			showInfoDialog: false,
			activeRow: null,
			popupTitle: '',
			projectContracts: [],
			popupActivo: false
			, currentLead: null
		};
	},
	watch: {
		async filterStatus() {
			this._findProjects();
		},
		async mutableOrder() {
			this._findProjects();
		},
		async "mutableFilters.approved_status"() {
			this._findProjects();
		},
		showInfoDialog: function () {
			if (!this.showInfoDialog) {
				this.showInfoDialog = false;
				this.activeRow = null;
				this.popupTitle = '';
				this.projectContracts = [];
			}
		}
	},
	async mounted() {
		this._findProjects();
		this.isMounted = true;
	},
	computed: {
		...mapState("projects", ["orderOptions", "status", "opsApprovedStatus"]),
		async filterStatus() {
			return this.mutableFilters["projects.status"];
		},
		currentPage: {
			get: function () {
				if (this.isMounted) {
					return this.$refs.table.currentx;
				}
				return 0;
			},
			set: function (val) {
				this.$refs.table.currentx = val;
			}
		},
		getTotalPages() {
			return Math.ceil(this.projects.length / this.itemsPerPage);
		},
	},
	methods: {
		...mapActions("projects", ["getProjectFromOpServices"]),
		async _findProjects() {
			let params = {
				page: this.current_page,
				term: this.term,
				filters: this.mutableFilters,
				order: this.mutableOrder,
				status: this.projectStatus,
				dateToConsult: this.dateToConsult,
				auxiliarDate: this.auxiliarDate
			};

			const projs = await this.getProjectFromOpServices(params);

			let projects = [];

			for (let index = 0; index < projs.length; index++) {
				const element = projs[index];
				let hasIdentityVerification = await this.getIdentityStatus(element.user_id);
				projects.push({
					id: element.id,
					alias: element.alias,
					tradename: element.tradename,
					tt: element.TT,
					light: element.triage,
					client: element.fiscal_name,
					status: element.status,
					statusStr: element.status_named,
					phone: this.getPhone(element.client.user),
					type: this.clientPersonType(element),
					pgmApplicant: element.pgm_potential_applicant,
					credit_acceptance_date: element.credit_acceptance_date,
					userId: element.user_id,
					identity: hasIdentityVerification
				});
			}
			this.projects = projects;
			this.currentPage = 1;
		},
		getPhone(user) {
			let phone;
			if (user.personal) {
				phone = `${user.personal.country_calling_code} ${user.personal.new_phone}`;
			} else {
				phone = `${user.business.country_calling_code} ${user.business.new_phone}`;
			}
			return phone;
		},
		updateItemsPerPage(it) {
			this.itemsPerPage = it;
			this.currentPage = 1;
		},
		async refreshTable() {
			this._findProjects();
		},
		async cleanTerm() {
			this.term = null;
			this._findProjects();
		},
		async handleSelected(proj) {
			window.open(`/project/${proj.id}`, '_blank');
		},
		async handleDblSelected(proj) {
			await this.$router.push(`/project/${proj.id}`);
		},
		clientPersonType(proj) {
			if (proj.client.user.person_type == this.PM_CLIENT_TYPE) {
				return "PM";
			}
			else {
				return proj.crowdfunding_loan_type === PF_CROWDFUNDING_LOAN_TYPE ? "PF" : "PFAE";
			}
		},
		clientTypeColor(type) {
			if (type == 'PF') {
				return "#1976d2";
			}
			else if (type == 'PM') {
				return "#7e57c2";
			}
			else {
				return "#24c1a0";
			}
		},
		statusColor(status) {
			switch (status) {
				case 1:
					return "#7cb342";
					break;
				case 2:
					return "#4dd0e1";
					break;
				case 3:
					return "#7cb342";
					break;
				case 4:
					return "#009688";
					break;
				case 6:
					return "#ab47bc";
					break;
				case 7:
					return "#2196f3";
					break;
				default:
					return "#2196f3";
			}
		},
		openInfoDialog(tr) {
			this.showInfoDialog = true;
			this.activeRow = tr;
			this.popupTitle = "Seguimiento Contratos PID " + tr.id + " " + tr.alias;
			axios.get('/api/project/' + tr.id + '/contracts/info').then(response => {
				this.projectContracts = response.data.data
			});
		},
		getZone(pgmApplicant) {
			if (pgmApplicant.subregion_manager_id !== null
				&& pgmApplicant.subregion_manager.region_manager_id !== null
				&& pgmApplicant.subregion_manager.region_manager.zone_manager_id !== null
				&& pgmApplicant.subregion_manager.region_manager.region !== null
				&& pgmApplicant.subregion_manager.region_manager.region.zone !== null
			) {
				return pgmApplicant.subregion_manager.region_manager.region.zone.name;
			}
		},
		getRegion(pgmApplicant) {
			if (pgmApplicant.subregion_manager_id !== null
				&& pgmApplicant.subregion_manager.region_manager_id !== null
				&& pgmApplicant.subregion_manager.region_manager.region !== null
			) {
				return pgmApplicant.subregion_manager.region_manager.region.name;
			}
		},
		async getIdentityStatus(userId) {
			const res = await this.getUserIdentity(userId);
			return res != null ? res.identity_status_str : "Sin registro";
		}
	},
};
</script>

<style scoped>
.triage {
	width: 1.5rem;
	height: 1.5rem;
	background-color: #ccc;
	margin-left: 1.5rem;
	border-radius: 5pc;
}

.triage-red {
	background-color: rgba(var(--vs-danger), 1);
}

.triage-yellow {
	background-color: rgba(var(--vs-warning), 1);
}

.triage-green {
	background-color: rgba(var(--vs-success), 1);
}

.con-vs-chip {
	font-size: 0.75rem !important;
}

.con-vs-chip.extended {
	font-size: 0.9rem !important;
}

.colored {
	color: rgba(var(--vs-primary), 1);
}
</style>
